import React, { FC } from 'react';

type ArrowRightProps = {
  /** The color of the icon. */
  color?: string;
};

const ArrowRight: FC<ArrowRightProps> = ({ color = 'currentColor' }) => (
  <svg height="100%" version="1.1" viewBox="0 0 12 10" width="100%">
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <path
        d="M11.707031,5.707031 L7.707031,9.707031 C7.511719,9.902344 7.257812,10.0000002 7,10.0000002 C6.742188,10.0000002 6.488281,9.902344 6.292969,9.707031 C5.902344,9.316406 5.902344,8.683594 6.292969,8.292969 L8.585938,6.00000025 L1,6.00000025 C0.449219,6.00000025 0,5.554688 0,5.00000025 C0,4.445312 0.449219,4.00000025 1,4.00000025 L8.585938,4.00000025 L6.292969,1.707031 C5.902344,1.316406 5.902344,0.683594 6.292969,0.292969 C6.683594,-0.097656 7.316406,-0.097656 7.707031,0.292969 L11.707031,4.292969 C12.097656,4.683594 12.097656,5.316406 11.707031,5.707031 Z"
        fill={color}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default ArrowRight;
